const Loading = () => {
  return (
    <div className="h-full flex justify-center items-center text-white">
      Loading...
    </div>
  );
};

export default Loading;
